// extracted by mini-css-extract-plugin
export var black = "styledButton-module--black--ee85c";
export var red = "styledButton-module--red--5d93f";
export var white = "styledButton-module--white--0c254";
export var wrapper = "styledButton-module--wrapper--295b8";